import { render, staticRenderFns } from "./dataEle.vue?vue&type=template&id=2edeaa6f&scoped=true&"
import script from "./dataEle.vue?vue&type=script&lang=js&"
export * from "./dataEle.vue?vue&type=script&lang=js&"
import style0 from "./dataEle.vue?vue&type=style&index=0&id=2edeaa6f&scoped=true&lang=css&"
import style1 from "./dataEle.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edeaa6f",
  null
  
)

export default component.exports